import * as types from '../../core/constants/ActionTypes';
import getQueryStringValue from '../components/url-reader/url-reader';

// this file/component contains all the URL parameters, create the new parameter and use it similar to other parameters.
// Create only  if you have added any new parameter in URL.
// (in the intialState we define url parameters so that it got initializeed at the start of th loading)
// reducer with initial state
const initialState = {
    lexType: getQueryStringValue('lexType'),
    cId: getQueryStringValue('cId'),
    lcoId: getQueryStringValue('lcoId'),
    sessionId: getQueryStringValue('key'),
    lmsId: getQueryStringValue('lId'),
    rcType: getQueryStringValue('rc_Type'),
    cType: getQueryStringValue('lcoId') ? '2' : '1',
    lang: getQueryStringValue('lang'),
    learnerId: getQueryStringValue('learnerId'),
    pId: getQueryStringValue('pId'),
    scUid: getQueryStringValue('scUid'),
    skUid: getQueryStringValue('skUid'),
    audience: getQueryStringValue('audience') === 'a' ? 'a' : '',
    clsAud: getQueryStringValue('cls_aud'),
    lmsUrl: null,
    error: null,
    isGuide: getQueryStringValue('isGuide') ? true : false,
    lpId: getQueryStringValue('lpId'),
    lpCode: getQueryStringValue('lpCode'),
    lpLaunchType: null,
    bId: 0,
    authVer: getQueryStringValue('authVersion'),
    pURL: getQueryStringValue('pURL'),
    aTy: getQueryStringValue('aTy'),
    tenantId: getQueryStringValue('tenantId'),
    nW: getQueryStringValue('nW'),
    ticket: getQueryStringValue('ticket')
};

export function urlReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LMS_URL:
            return {
                ...state,
                lmsUrl: action.payload,
                error: null
            };

        case types.SET_SESSION_ID:
            return {
                ...state,
                sessionId: action.payload,
                error: null
            };
        case types.SET_LERNERID_ID:
            return {
                ...state,
                learnerId: action.payload
            };
        case types.SET_CONTENT_PARAMS:
            // console.log('set content params');
            return {
                ...state,
                cId: action.payload.cId,
                lcoId: action.payload.lcoId,
                cType: action.payload.cType,
                lang: action.payload.lang,
                learnerId: action.payload.learnerId,
                lpLaunchType: action.payload.fType,
                title: action.payload.title,
                bId: action.payload.bId
            };
        case types.SET_LANG:
            // console.log('set lang');
            return {
                ...state,
                lang: action.payload
            };
        case types.SET_LP_ID:
            // set LP id
            return {
                ...state,
                lpId: action.payload
            };
        default:
            return state;
    }
}
